import { render } from "./SpecialProcessPartTable.vue?vue&type=template&id=4ffca612&ts=true&lang=pug"
import script from "./SpecialProcessPartTable.vue?vue&type=script&lang=ts"
export * from "./SpecialProcessPartTable.vue?vue&type=script&lang=ts"

import "./SpecialProcessPartTable.vue?vue&type=style&index=0&id=4ffca612&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__